import { z } from 'zod';
export const usernameSchema = z
    .string()
    .trim()
    .min(3, 'Username must be at least 3 characters')
    .max(32, 'Username must be at most 32 characters')
    .regex(/^[a-zA-Z0-9._-]+$/, 'Use letters, digits, dot, underscore or hyphen only');
export const passwordSchema = z
    .string()
    .min(8, 'Password must be at least 8 characters')
    .max(200, 'Password must be at most 200 characters');
export const registerInputSchema = z.strictObject({
    username: usernameSchema,
    password: passwordSchema,
});
export const loginInputSchema = z.strictObject({
    username: z.string().trim().min(1, 'Username is required'),
    password: z.string().min(1, 'Password is required'),
});
/** What an account is allowed to do. Extend rather than add booleans. */
export const USER_ROLES = ['user', 'admin'];
//# sourceMappingURL=auth.js.map